<template>
  <div :class="classObject" id="dataPaginationSwap">
    <template v-if="useBtnStyle">
      <div
        :class="
          listData.length > splitNum
            ? 'dataPaginationSwap-contentBtn'
            : 'dataPaginationSwap-contentBtn fullHeight'
        "
      >
        <div
          v-for="item in splitArray"
          :key="item.name"
          :class="
            hasBtnDescription
              ? item.state == '运行中'
                ? 'datasBtn datasBtnActive'
                : 'datasBtn'
              : item.state == '运行中'
              ? 'datasBtn datasBtnExtend datasBtnActive'
              : 'datasBtn datasBtnExtend'
          "
        >
          <div class="datasBtn-name">
            <div class="datasBtn-name-text" :title="item.name">
              {{ item.name }}
            </div>
            <div class="datasBtn-name-state">({{ item.state }})</div>
          </div>
          <template v-if="hasBtnDescription">
            <div class="datasBtn-value">{{ item.value }}</div>
            <div class="datasBtn-description">{{ item.description }}</div>
          </template>
          <template v-else>
            <div class="datasBtn-params">
              <div
                v-for="(v, i) in item.value"
                :key="i"
                class="datasBtn-params-item"
              >
                <div class="datasBtn-params-item-name">{{ v.name }}</div>
                <div class="datasBtn-params-item-value" :title="v.value">{{ v.value }}</div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </template>
    <template v-else-if="useGaugeStyle">
      <div class="dataPaginationSwap-contentGauge">
        <div
          v-for="(item, index) in splitArray"
          :key="`${chartsId}-${index}-${currentPage}-${item.name}`"
          class="datasGauge"
        >
          <PublicEcharts
            :id="`${chartsId}-${index}-${currentPage}-${item.name}`"
            :chartsData="item"
            :options="dealGaugeData(item)"
            usePropsOptions
          />
        </div>
      </div>
    </template>
    <template v-else-if="useEfficiencyStyle">
      <div class="dataPaginationSwap-contentEfficiency">
        <div
          v-for="(item, index) in splitArray"
          :key="`${chartsId}-${index}-${currentPage}-${item.name}`"
          class="datasEfficiency"
        >
          <div class="datasEfficiency-echarts">
            <PublicEcharts
              :id="`${chartsId}-${index}-${currentPage}-${item.name}`"
              :chartsData="item.echartsData"
              :options="dealEfficiencyData(item.echartsData)"
              usePropsOptions
            />
          </div>
          <div class="datasEfficiency-text">
            <div class="firstDiv">
              <div>
                <span>{{ item.name }}</span>
              </div>
            </div>
            <div class="secondDiv">
              <span :title="item.realValue" class="highlight">{{
                dealBigNum(dealNumWith(item.realValue, 2))
              }}</span>
            </div>
            <div class="thirdDiv">
              <div v-if="!!item.realUnit">
                <span>{{
                  `${item.realName || realNameDefault}(${item.realUnit})`
                }}</span>
              </div>
              <div v-else>
                <span>{{ item.realName || realNameDefault }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="dataPaginationSwap-content">
        <div v-for="item in splitArray" :key="item.name" class="datas">
          <div v-if="showName" class="datas-name" :title="item.name">
            {{ item.name }}
          </div>
          <div class="datas-value">
            <HeadTips
              v-if="useHeadTips"
              :listData="item.value || []"
              :className="classNameTitleTipsItem"
              :combineNameUnit="combineNameUnit"
              :twoLine="twoLineHeadTips"
            />
            <TitleTipsItem
              v-else
              :listData="item.value || []"
              :modalFlag="twoLine ? 2 : 1"
              :combineNameUnit="combineNameUnit"
              :className="classNameTitleTipsItem"
            />
          </div>
        </div>
      </div>
    </template>
    <div
      v-if="listData.length > splitNum"
      class="dataPaginationSwap-pagination"
    >
      <el-pagination
        :current-page="currentPage"
        @current-change="handleCurrentChange"
        hide-on-single-page
        layout="prev, pager, next"
        :page-size="splitNum"
        :total="listData.length"
        :small="smallPagination"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { dealBigNum, dealNumWith } from "@/assets/js/utils";
import HeadTips from "@/components/HeadTips/HeadTips.vue";
import TitleTipsItem from "@/components/TitleTips/TitleTipsItem.vue";
import PublicEcharts from "@/components/PublicEcharts";
const classNames = require("classnames");
export default {
  components: {
    HeadTips,
    TitleTipsItem,
    PublicEcharts,
  },
  name: "DataPagination",
  props: {
    showName: {
      type: Boolean,
      default: true,
    },
    //useHeadTips决定用HeadTips还是TitleTipsItem
    useHeadTips: {
      type: Boolean,
      default: false,
    },
    twoLineHeadTips: {
      type: Boolean,
      default: false,
    },
    listData: {
      type: Array,
      default: () => [],
    },
    splitNum: {
      type: Number,
      default: 2,
    },
    twoLine: {
      type: Boolean,
      default: false,
    },
    className: {
      type: String,
      default: "",
    },
    classNameTitleTipsItem: {
      type: String,
      default: "",
    },
    combineNameUnit: {
      type: Boolean,
      default: false,
    },
    smallPagination: {
      type: Boolean,
      default: false,
    },
    useBtnStyle: {
      type: Boolean,
      default: false,
    },
    hasBtnDescription: {
      type: Boolean,
      default: false,
    },
    useGaugeStyle: {
      type: Boolean,
      default: false,
    },
    chartsId: {
      type: String,
      default: "gauge",
    },
    useEfficiencyStyle: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentPage: 1,
    };
  },
  methods: {
    handleCurrentChange(val) {
      this.currentPage = val;
    },
    dealGaugeData(data) {
      const { name, unit, value, up = 100, down = 0 } = data;
      const sub_title = `${value}${unit}`;

      // 获取比率
      const rate = value / up;
      // 渲染数据
      const option = {
        title: {
          show: true,
          text: name,
          x: "47%",
          y: "52%",
          z: 8,
          textAlign: "center",
          textStyle: {
            color: "#f1f7fe",
            fontSize: 14,
            fontWeight: "normal",
          },
        },
        series: [
          {
            name: "内部（环形）进度条",
            type: "gauge",
            // center: pos_info,
            radius: "80%",
            splitNumber: 10,
            axisLine: {
              lineStyle: {
                color: [
                  [rate, "#458EFD"],
                  [1, "#edf1f7"],
                ],
                width: 7,
              },
            },
            axisLabel: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            pointer: {
              show: false,
            },
          },
          {
            name: "外部刻度",
            type: "gauge",
            //  center: ['20%', '50%'],
            radius: "90%",
            min: down, //最小刻度
            max: up, //最大刻度
            splitNumber: 10, //刻度数量
            startAngle: 225,
            endAngle: -45,
            axisLine: {
              show: false,
              // 仪表盘刻度线
              lineStyle: {
                width: 1,
                color: [[1, "#FFFFFF"]],
              },
            },
            //仪表盘文字
            axisLabel: {
              show: true,
              color: "#868FDF",
              distance: 2,
              formatter: function (v) {
                switch (v) {
                  case down:
                    return down;
                  case up:
                    return up;
                }
              },
            }, //刻度标签。
            axisTick: {
              show: false,
              splitNumber: 5,
              lineStyle: {
                color: "#3082FE", //用颜色渐变函数不起作用
                width: 1,
              },
              length: -8,
              distance: 6,
            }, //刻度样式
            splitLine: {
              show: false,
              length: -12,
              lineStyle: {
                color: "#458EFD", //用颜色渐变函数不起作用
              },
              distance: 6,
            }, //分隔线样式
            detail: {
              show: false,
            },
            pointer: {
              show: false,
            },
          },
          /*内部*/
          {
            type: "pie",
            radius: ["0", "60%"],
            center: ["50%", "50%"],
            z: 8,
            hoverAnimation: false,
            data: [
              {
                name: name,
                value: value,
                itemStyle: {
                  normal: {
                    color: new this.$echarts.graphic.LinearGradient(
                      0,
                      0,
                      0,
                      1,
                      [
                        {
                          offset: 0,
                          color: "#3D9CFE",
                        },
                        {
                          offset: 1,
                          color: "#b3d2ff",
                        },
                      ]
                    ),
                  },
                },
                label: {
                  normal: {
                    formatter: function (params) {
                      // return params.value + '%';
                      return sub_title;
                    },
                    color: "#FFFFFF",
                    fontSize: 14,
                    fontWeight: "bold",
                    position: "center",
                    show: true,
                  },
                },
                labelLine: {
                  show: false,
                },
              },
            ],
          },
          /*外一层*/
          // {
          //     type: "pie",
          //     radius: "45%",
          //     startAngle: 220,
          //     endAngle: -40,
          //     hoverAnimation: false,
          //     center: ["50%", "50%"],
          //     avoidLabelOverlap: false,
          //     label: {
          //         show: false
          //     },
          //     labelLine: {
          //         show: false
          //     },
          //     data: [{
          //         value: 1,
          //         itemStyle: {
          //             normal: {
          //                 color: '#8DC4FD'
          //             }
          //         }
          //     }],
          // },
          //外二层圈
          // {
          //     type: "pie",
          //     radius: "50%",
          //     center: ["50%", "50%"],
          //     avoidLabelOverlap: false,
          //     z: 0,
          //     hoverAnimation: false,
          //     label: {
          //         show: false
          //     },
          //     labelLine: {
          //         show: false
          //     },
          //     data: [{
          //         "value": 1,
          //         itemStyle: {
          //             normal: {
          //                 color: '#e3edf8'
          //             }
          //         }
          //     }]
          // }
        ],
      };
      return option;
    },
    dealEfficiencyData(data = {}) {
      const { value } = data;
      let optionDefault = {
        title: {
          text: "负荷率",
          x: "center",
          y: "40%",
          textStyle: {
            color: "#999",
            fontSize: 12,
            align: "center",
          },
          subtext: `${value}%`,
          subtextStyle: {
            fontSize: 14,
            color: "#999",
          },
        },
        tooltip: {
          show: false,
        },
        legend: {
          show: false,
        },
        color: ["#28CCCB", "#F4F6F7"],
        series: [
          {
            type: "pie",
            radius: ["40%", "60%"],
            cursor: "default",
            data: [
              {
                name: "负荷率",
                value,
                emphasis: {
                  disabled: true,
                },
              },
              {
                name: "总数",
                value: 100 - value,
                emphasis: {
                  disabled: true,
                },
              },
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
            label: {
              show: false,
            },
          },
        ],
      };
      return optionDefault;
    },
    dealBigNum,
    dealNumWith,
  },
  computed: {
    classObject: function () {
      return classNames({
        dataPaginationSwap: true,
        twoLine: this.twoLine,
        [this.className]: !!this.className,
      });
    },
    splitArray: function () {
      return this.listData.slice(
        (this.currentPage - 1) * this.splitNum,
        this.currentPage * this.splitNum
      );
    },
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.dataPaginationSwap {
  width: 100%;
  height: 110px;

  &-content {
    width: 100%;
    @include setFlexBetween;

    .datas {
      @include setFlexColumn;

      &-name {
        width: 100%;
        height: 20px;
        // font-weight: bold;
        color: #666;
        text-align: center;
        margin-bottom: 5px;
        @include setEllipsis;
      }

      &-value {
        @include setFlexBetween;
        // margin-top: 5px;
      }
    }
  }

  &-contentBtn {
    width: 100%;
    @include setFlexAround;
    height: 80px;

    .datasBtn {
      width: 30%;
      height: 100%;
      border-radius: 6px;
      border: 1px solid #979797;
      @include setFlexColumn;
      justify-content: space-evenly;

      &-name {
        height: 14px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #666666;
        line-height: 14px;
        width: 100%;
        @include setFlexCenter;

        &-text {
          max-width: calc(100% - 80px);
          text-align: right;
          @include setEllipsis;
        }

        &-state {
          width: 55px;
          text-align: left;
        }
      }

      &-value {
        height: 20px;
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 20px;
        width: 100%;
        @include setFlexCenter;
      }

      &-description {
        height: 12px;
        font-size: 12px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #666666;
        line-height: 12px;
        width: 100%;
        @include setFlexCenter;
      }

      &-params {
        font-weight: 500;
        @include setFlexCenter;

        &-item {
          width: 45%;
          @include setFlexCenter;

          &-name {
            color: #666666;
            font-size: 12px;
          }

          &-value {
            margin-left: 5px;
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            color: #333333;
          }
        }
      }
    }

    .datasBtnActive {
      border: 2px solid #28cccb;

      .datasBtn-name-state {
        color: #28cccb;
      }

      .datasBtn-value {
        color: #28cccb;
      }

      .datasBtn-params-item-value {
        color: #28cccb;
      }
    }

    .datasBtnExtend {
      width: 90%;
      height: 40%;
    }
  }

  &-contentGauge {
    margin-top: 5px;
    width: 100%;
    @include setFlexAround;
    height: 160px;

    .datasGauge {
      width: 24%;
      height: 100%;
    }
  }

  &-contentEfficiency {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
    height: calc(100% - 32px);

    .datasEfficiency {
      width: 49%;
      height: 180px;
      @include setFlexStart;
      &-echarts {
        width: 180px;
        height: 180px;
      }
      &-text {
        width: calc(100% - 190px);
        height: 120px;
        @include setFlexColumn;
        align-items: center;
        justify-content: center;
        & > div {
          width: 100%;
          display: flex;
          justify-content: center;
        }

        .firstDiv {
          font-size: 18px;
          font-weight: bold;
        }

        .secondDiv {
          margin-top: 8px;

          .highlight {
            color: #28cccb;
            font-weight: bold;
            font-size: 30px;
          }
        }

        .thirdDiv {
          margin-top: 8px;
          font-size: 14px;
          font-weight: bold;
          @include setFlexCenter;

          .value {
            margin-left: 10px;
          }
        }
      }
    }
  }

  .fullHeight {
    height: 100%;
  }

  &-pagination {
    height: 20px;
    text-align: center;
    margin-top: 10px;
  }
}
</style>
